var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 13C8.15625 13 8 12.8438 8 12.625V5.875C8 5.6875 8.15625 5.5 8.375 5.5H9.125C9.3125 5.5 9.5 5.6875 9.5 5.875V12.625C9.5 12.8438 9.3125 13 9.125 13H8.375ZM13.5 2.5C13.75 2.5 14 2.75 14 3V3.5C14 3.78125 13.75 4 13.5 4H13V14.5C13 15.3438 12.3125 16 11.5 16H2.5C1.65625 16 1 15.3438 1 14.5V4H0.5C0.21875 4 0 3.78125 0 3.5V3C0 2.75 0.21875 2.5 0.5 2.5H3.0625L4.125 0.75C4.375 0.3125 4.875 0 5.40625 0H8.5625C9.09375 0 9.59375 0.3125 9.84375 0.75L10.9062 2.5H13.5ZM5.34375 1.59375L4.8125 2.5H9.15625L8.625 1.59375C8.59375 1.5625 8.53125 1.5 8.46875 1.5H5.53125C5.5 1.5 5.5 1.5 5.5 1.5C5.4375 1.5 5.375 1.5625 5.34375 1.59375ZM11.5 14.5V4H2.5V14.5H11.5ZM4.875 13C4.65625 13 4.5 12.8438 4.5 12.625V5.875C4.5 5.6875 4.65625 5.5 4.875 5.5H5.625C5.8125 5.5 6 5.6875 6 5.875V12.625C6 12.8438 5.8125 13 5.625 13H4.875Z",
    fill: "#6E737E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default __webpack_public_path__ + "static/media/trash-alt.c114908ce25719a1198deb2fa0132c87.svg";
export { ForwardRef as ReactComponent };